import { createContext, useContext } from "react"

export type AppRouteAuthUser = {
  email: string
  firstName: string
  id: number
  lastName: string
}

export type AppRouteAuthMembership = {
  organisation: {
    id: number
  }
}

export type AppRouteAuthOrganisation = {
  id: number
}

export type AppRouteAuthState = {
  activeOrganisation: AppRouteAuthOrganisation | null
  authenticated: boolean
  memberships: AppRouteAuthMembership[]
  requiresOrganisationSetup: boolean
  user: AppRouteAuthUser | null
}

export const AuthenticatedAppRouteContext = createContext<AppRouteAuthState | null>(null)

export function useAuthenticatedAppRouteState() {
  const authState = useContext(AuthenticatedAppRouteContext)
  if (!authState) {
    throw new Error("useAuthenticatedAppRouteState must be used within AuthenticatedAppRoute.")
  }
  return authState
}
